import { Vertical } from '@amzn/aet-coachingform-kit';
import { QuestionOption } from '../../../Util/Form/formData.types';
import { FORM_DISPLAY_NAMES } from '../../../Util/Form/formSectionConstants';
import { D2_VERTICALS, convertToVerticalOption } from '../../../Util/Vertical';

/**
 * Applies backward compatibility rules to form options for existing draft forms
 * This ensures that draft forms retain their original form type options even
 * when feature flags would normally change available options
 */
export const applyBackwardCompatibilityRules = (
  options: QuestionOption[],
  vertical: string,
  formType: string,
  enabledD2Form: boolean
): QuestionOption[] => {
  const updatedOptions = [...options];

  // D2AS + TMF draft compatibility
  const verticalOption = convertToVerticalOption(vertical);
  if (
    D2_VERTICALS.has(verticalOption) &&
    enabledD2Form &&
    formType === FORM_DISPLAY_NAMES.TRANSACTION_MONITORING_FORM
  ) {
    updatedOptions.unshift({
      DEFAULT_MESSAGE: FORM_DISPLAY_NAMES.TRANSACTION_MONITORING_FORM,
      TRANSLATION_ID: 'cs_perfportal_tx_monitoring_form_title',
      VALUE: 0,
    });
  }

  // Future compatibility rules can be added here

  return updatedOptions;
};

export const defaultFormOptions = {
  [Vertical.SDSRecipient]: [
    {
      DEFAULT_MESSAGE: 'Transaction monitoring form',
      TRANSLATION_ID: 'cs_perfportal_tx_monitoring_form_title',
      VALUE: 0,
    },
    {
      DEFAULT_MESSAGE: 'Recipient review form',
      TRANSLATION_ID: 'cs_perfportal_recipient_review_form_title',
      VALUE: 1,
    },
  ],
  [Vertical.D2AS]: [
    {
      DEFAULT_MESSAGE: 'Transaction monitoring form',
      TRANSLATION_ID: 'cs_perfportal_tx_monitoring_form_title',
      VALUE: 0,
    },
  ],
  [Vertical.SDSNonDelivery]: [
    {
      DEFAULT_MESSAGE: 'Transaction monitoring form',
      TRANSLATION_ID: 'cs_perfportal_tx_monitoring_form_title',
      VALUE: 0,
    },
    {
      DEFAULT_MESSAGE: 'Non-Delivery review form',
      TRANSLATION_ID: 'cs_perfportal_non_delivery_review_form_title',
      VALUE: 2,
    },
  ],
  [Vertical.SDSCAP]: [
    {
      DEFAULT_MESSAGE: 'Transaction monitoring form',
      TRANSLATION_ID: 'cs_perfportal_tx_monitoring_form_title',
      VALUE: 0,
    },
    {
      DEFAULT_MESSAGE: 'CAP Review Form',
      TRANSLATION_ID: 'cs_perfportal_cap_form_title',
      VALUE: 3,
    },
  ],
  [Vertical.SDSDSL]: [
    {
      DEFAULT_MESSAGE: 'Transaction monitoring form',
      TRANSLATION_ID: 'cs_perfportal_tx_monitoring_form_title',
      VALUE: 0,
    },
  ],
};
